export type TableOrderLookupState = 'not_requested' | 'active' | 'empty' | 'failed'

export function shouldRestoreRecoveredLocalDraft(input: {
  online: boolean
  tableOrderLookup: TableOrderLookupState
  orderId?: number | string | null
}): boolean {
  if (!input.online || input.tableOrderLookup === 'failed' || input.tableOrderLookup === 'not_requested') {
    return true
  }

  if (input.tableOrderLookup === 'active') return false

  // A successful empty response proves a persisted server order is no longer active.
  // Local drafts without a server identity can still be legitimate unsynced work.
  return input.orderId == null
}

export function isMatchingEmptyTableCartIntent(input: {
  snapshot?: { cleared?: boolean; orderId?: number | string | null; draftGeneration?: number | null } | null
  orderId?: number | string | null
  draftGeneration?: number | null
}): boolean {
  const snapshot = input.snapshot
  if (!snapshot?.cleared) return false

  if (snapshot.orderId != null) {
    return input.orderId != null
      && String(snapshot.orderId) === String(input.orderId)
      && snapshot.draftGeneration != null
      && input.draftGeneration != null
      && snapshot.draftGeneration === input.draftGeneration
  }

  return snapshot.draftGeneration != null
    && input.draftGeneration != null
    && snapshot.draftGeneration === input.draftGeneration
}

export function canRebaseTableDraftConflict(input: {
  expectedOrderId?: number | string | null
  conflictOrderId?: number | string | null
  expectedCartRevision?: number | null
  conflictCartRevision?: number | null
}): boolean {
  if (input.expectedOrderId == null || input.conflictOrderId == null) return false
  if (String(input.expectedOrderId) !== String(input.conflictOrderId)) return false
  if (input.expectedCartRevision == null || input.conflictCartRevision == null) return false

  return Number(input.expectedCartRevision) === Number(input.conflictCartRevision)
}
